import PropTypes from 'prop-types'
import { Input, Label } from 'reactstrap'
import { PER_PAGE_OPTIONS } from 'domains/product/constants'

const propTypes = {
  perPage               : PropTypes.string,
  handlePerPageOnChange : PropTypes.func
}

const defaultProps = {
  perPage               : '10',
  handlePerPageOnChange : () => { }
}

const ProductPerPageFilterField = ({
  perPage,
  handlePerPageOnChange
}) => (
  <>
    <Label>{ 'Per Page' }</Label>
    <Input
      name="per_page"
      type='select'
      value={ perPage }
      onChange={ (e) => {handlePerPageOnChange(e)} }
    >
      {
        PER_PAGE_OPTIONS.map((item) => (
          <option
            key={ item.value }
            value={ item.value }
            label = { item.label }
          />
        ))
      }
    </Input>
  </>
)

ProductPerPageFilterField.propTypes    = propTypes
ProductPerPageFilterField.defaultProps = defaultProps

export default ProductPerPageFilterField
